import { createContext, useContext, useEffect, useState, useCallback } from "react";
import {
  fetchMe,
  getCachedUser,
  loginRequest,
  logoutRequest,
} from "../utils/auth";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    const cached = getCachedUser();
    if (cached) setUser(cached);

    // Verify session via /me — cookie or localStorage token.
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => setUser(false))
      .finally(() => setBooted(true));
  }, []);

  // Step 1: password check only. Returns { preauthToken, totpEnrolled };
  // user state is NOT set here — call completeLogin() after 2FA succeeds.
  const login = useCallback(async (nip, password) => {
    return loginRequest(nip, password);
  }, []);

  // Called with the user object returned by twoFaVerify/twoFaActivate.
  const completeLogin = useCallback((userData) => {
    setUser(userData);
  }, []);

  const logout = useCallback(async () => {
    await logoutRequest();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, booted, login, completeLogin, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
